// NodeTypePill.jsx

import React from 'react';

// Context
import { useCurrentLanguage } from 'context/LanguageContext';
import { useNodeTypes } from 'context/NodeTypesContext';

// CSS
import './NodeTypePill.css';

/**
 * NodeTypePill
 * 
 * A versatile button component, in glass style, that can display an icon and/or a label.
 * 
 * @param {object} node - The node object containing type information.
 * 
 * @returns {ReactNode} NodeTypePill component.
 */
const NodeTypePill = React.memo(({ node }) => {

    // ----- CONTEXT ----- //

    // Node Type Context

    const { getLabel } = useNodeTypes();

    // Language Context
    const language = useCurrentLanguage();

    const effectiveType = node?.type;
    const nodeTypeLabel = getLabel(effectiveType, language);

    if (!node || !effectiveType) return null;

    // ----- RENDER ----- //

    return (

        <div
          className="node-type-pill-container"
        >

            {/* TEXT */}
            <div
              className="node-type-pill-label"
            >
                {nodeTypeLabel}
            </div>

        </div>
    );
});

// Dev Tools
NodeTypePill.displayName = 'NodeTypePill';

export default NodeTypePill;
